import { Question } from './question.js';
import { THUMB_EMOJIS, FACE_3_EMOJIS, FACE_5_EMOJIS, face3ImageEmojis, face5ImageEmojis } from '../icons/emoji-data.js';
import { CONFIG } from '../config.js';

export class EmojiQuestion extends Question {
    renderContent() {
        let selectedEmojis = '';
        const emojisBlock = document.createElement('div');
        emojisBlock.classList.add('ph-emoji');
        if (this.question.emojis === 'thumb') {
            emojisBlock.style.gap = '4px';
        } else {
            emojisBlock.style.gap = '16px';
        }
        emojisBlock.setAttribute('role', 'group');
        emojisBlock.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);

        let emojisThumbBasic = THUMB_EMOJIS;

        let emoji3Faces = face3ImageEmojis(CONFIG.cdnBaseUrl, this.question.emojiSettings.size);

        let emoji5Faces = face5ImageEmojis(CONFIG.cdnBaseUrl, this.question.emojiSettings.size);

        let emoji3FacesNew = FACE_3_EMOJIS;

        let emoji5FacesNew = FACE_5_EMOJIS;

        let colorGroupFiveFaces = [];
        let colorGroupThreeFaces = [];
        let colorGroupThumbs = [];
        if (this.question.emojiSettings.colorType === 'custom') {
            colorGroupFiveFaces = [
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
            ];
            colorGroupThreeFaces = [
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
            ];
            colorGroupThumbs = [
                this.question.emojiSettings.color,
                this.question.emojiSettings.color,
            ];
        } else if (this.question.emojiSettings.colorType === 'trafficLight') {
            colorGroupFiveFaces = [
                '#AF2D4C',
                '#DD7418',
                '#F0BA5B',
                '#65C36B',
                '#228700',
            ];
            colorGroupThreeFaces = [
                '#AF2D4C',
                '#F0BA5B',
                '#65C36B',
            ];
            colorGroupThumbs = [
                '#AF2D4C',
                '#228700',
            ];
        } else if (this.question.emojiSettings.colorType === 'blackWhite') {
            colorGroupFiveFaces = [
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
            ];
            colorGroupThreeFaces = [
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
            ];
            colorGroupThumbs = [
                this.style.textColor || '#000000',
                this.style.textColor || '#000000',
            ];
        }

        const thumbLabels = ['Thumbs down', 'Thumbs up'];
        if (this.question.emojis === 'thumb') {
            emojisBlock.style.width = '100%';
            emojisBlock.style.alignItems = 'stretch';

            const hasLabels = !!((this.question.emojiSettings && this.question.emojiSettings.negativeText) || 
                                 (this.question.emojiSettings && this.question.emojiSettings.positiveText));

            emojisThumbBasic.forEach((emoji, index) => {
                let optionContainer = document.createElement('div');
                optionContainer.classList.add('ph-emoji__thumb-item');

                let emojiElement = document.createElement('div');
                emojiElement.classList.add('ph-emoji__item', 'ph-emoji__thumb-btn');
                if (index === 0) {
                    emojiElement.classList.add('ph-emoji__thumb-btn--down');
                } else {
                    emojiElement.classList.add('ph-emoji__thumb-btn--up');
                }
                emojiElement.innerHTML = emoji;
                emojiElement.style.color = colorGroupThumbs[index];

                emojiElement.id = 'thumb' + index;
                this.makeKeyboardActivatable(emojiElement);
                emojiElement.setAttribute('aria-label', thumbLabels[index] || `Emoji ${index + 1}`);
                emojiElement.addEventListener('click', () => {
                    selectedEmojis = 'thumb' + index;
                    this.ctx.goNext(this.question, selectedEmojis);
                });
                optionContainer.appendChild(emojiElement);

                if (hasLabels) {
                    let textContainer = document.createElement('div');
                    textContainer.classList.add('ph-emoji__thumb-text');

                    if (index === 0) {
                        textContainer.classList.add('ph-emoji__thumb-text--left');
                        textContainer.textContent = (this.question.emojiSettings && this.question.emojiSettings.negativeText) || '';
                    } else {
                        textContainer.classList.add('ph-emoji__thumb-text--right');
                        textContainer.textContent = (this.question.emojiSettings && this.question.emojiSettings.positiveText) || '';
                    }

                    optionContainer.appendChild(textContainer);
                }

                emojisBlock.appendChild(optionContainer);
            });
        }

        const face3Labels = ['Unhappy', 'Neutral', 'Happy'];
        if (this.question.emojis === 'face') {
            emoji3FacesNew.forEach((emoji, index) => {
                let emojiElement = document.createElement('div');
                emojiElement.classList.add('ph-emoji__item');
                emojiElement.innerHTML = emoji;
                emojiElement.style.color = colorGroupThreeFaces[index];
                emojiElement.style.width = `${this.question.emojiSettings.size}px`;
                emojiElement.style.height = `${this.question.emojiSettings.size}px`;
                emojiElement.id = 'face' + index;
                this.makeKeyboardActivatable(emojiElement);
                emojiElement.setAttribute('aria-label', face3Labels[index] || `Emoji ${index + 1}`);
                emojiElement.addEventListener('click', () => {
                    selectedEmojis = 'face' + index;
                    this.ctx.goNext(this.question, selectedEmojis);
                });
                emojisBlock.appendChild(emojiElement);
            });
        }

        if (this.question.emojis === '3faces') {
            emoji3Faces.forEach((emoji, index) => {
                let emojiElement = document.createElement('div');
                emojiElement.classList.add('ph-emoji__item');
                emojiElement.innerHTML = emoji;
                emojiElement.style.width = `${this.question.emojiSettings.size}px`;
                emojiElement.style.height = `${this.question.emojiSettings.size}px`;
                emojiElement.id = '3faces' + index;
                this.makeKeyboardActivatable(emojiElement);
                emojiElement.setAttribute('aria-label', face3Labels[index] || `Emoji ${index + 1}`);
                emojiElement.addEventListener('click', () => {
                    selectedEmojis = 'threeFaces' + index;
                    this.ctx.goNext(this.question, selectedEmojis);
                });
                emojisBlock.appendChild(emojiElement);
            });
        }

        const face5Labels = ['Very unhappy', 'Unhappy', 'Neutral', 'Happy', 'Very happy'];
        if (this.question.emojis === '5faces') {
            emoji5Faces.forEach((emoji, index) => {
                let emojiElement = document.createElement('div');
                emojiElement.classList.add('ph-emoji__item');
                emojiElement.innerHTML = emoji;
                emojiElement.style.width = `${this.question.emojiSettings.size}px`;
                emojiElement.style.height = `${this.question.emojiSettings.size}px`;
                emojiElement.id = '5faces' + index;
                this.makeKeyboardActivatable(emojiElement);
                emojiElement.setAttribute('aria-label', face5Labels[index] || `Emoji ${index + 1}`);
                emojiElement.addEventListener('click', () => {
                    selectedEmojis = 'fiveFaces' + index;
                    this.ctx.goNext(this.question, selectedEmojis);
                });
                emojisBlock.appendChild(emojiElement);
            });
        }

        if (this.question.emojis === 'new5faces') {
            emoji5FacesNew.forEach((emoji, index) => {
                let emojiElement = document.createElement('div');
                emojiElement.classList.add('ph-emoji__item');
                emojiElement.innerHTML = emoji;
                emojiElement.style.color = colorGroupFiveFaces[index];
                emojiElement.style.width = `${this.question.emojiSettings.size}px`;
                emojiElement.style.height = `${this.question.emojiSettings.size}px`;
                emojiElement.id = 'new5faces' + index;
                this.makeKeyboardActivatable(emojiElement);
                emojiElement.setAttribute('aria-label', face5Labels[index] || `Emoji ${index + 1}`);
                emojiElement.addEventListener('click', () => {
                    selectedEmojis = 'newFiveFaces' + index;
                    this.ctx.goNext(this.question, selectedEmojis);
                });
                emojisBlock.appendChild(emojiElement);
            });
        }

        return emojisBlock;
    }
}
